<!--  eslint-disable -->
<div #mapElementRef id="map" class="map"></div>

<div
  class="absolute top-4 right-4 z-20"
  *ngIf="connectionService.isOnline | async as connectionStatus"
>
  <span
    [ngClass]="connectionStatus ? 'text-green-500' : 'text-red-500'"
    class="fa fa-wifi text-lg"
  ></span>
</div>


@if((mapService.createPropertyToolActive | async) === false &&
!isAnyEskToolActive()) {
<app-active-property
  @slideFadeInOut
  (downloadLayers)="mapService.downloadClippedLayers(paddocks)"
></app-active-property>
}

<app-base-float [layerGroup]="mapService.basemapGroup"></app-base-float>

<map-toolbar
 data-tour="step1"
  orientation="vertical"
  position="left"
  classes="top-20 bg-white/50"
>
  <app-zoom
    [map]="mapService.map"
  ></app-zoom>
  <app-gps
    [map]="mapService.map"
  ></app-gps>
  <map-measure
    [map]="mapService.map"
  ></map-measure>
  <app-graticle
    [map]="mapService.map"
  ></app-graticle>
  <map-select
    [map]="mapService.map"
    [layers]="getSelectLayers()"

  ></map-select>
  <app-digitize-paddock
    [map]="mapService.map"
    [snapLayers]="[mapService.propertyLayer, mapService.paddockLayer]"
    (paddockDigitized)="createPaddock($event)"
    (active)="paddockToolClicked($event)"
  ></app-digitize-paddock>
  <app-digitize-fence
    [map]="mapService.map"
    [snapLayers]="[mapService.propertyLayer, mapService.paddockLayer]"
    (fenceCreated)="fenceCreated($event)"
    (active)="fenceToolClicked($event)"
  ></app-digitize-fence>
</map-toolbar>


<div
  id="processingWindow"
  [ngClass]="{
    'fixed inset-0 bg-black/50 flex items-center justify-center z-[9999999999999999999]':
      processing,
    hidden: !processing
  }"
>
  <div class="bg-white rounded-lg p-8 text-center">
    <p class="text-lg text-gray-700 mb-4">
      {{ processingText }}...<br />{{ processingLayerText }}...
    </p>
    <div
      class="w-8 h-8 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto"
    ></div>
  </div>
</div>

<div #addAttributeOverlayHere></div>

<sidebar-overlay>
  <!-- Layers Sidebar Item -->
  <sidebar-item
    id="layers"
    title="Layers"
    className="fa fa-layer-group"
    [position]="1"
  >
    <ng-template #sidebarIcon>
      <i class="fa fa-layer-group"></i>
    </ng-template>

    <ng-template #header>
      <div class="flex items-center justify-between">
        <h2 class="text-lg font-semibold">Layers</h2>
        <button class="text-gray-500 hover:text-gray-700">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </ng-template>

    <ng-template #content>
      <div class="p-4">
        <app-analysis-group
          (downloadLayers)="mapService.downloadClippedLayers(paddocks)"
          [layerGroup]="mapService.enterpriseSuitibilityGroupProperty"
        ></app-analysis-group>
        <app-analysis-group
          (downloadLayers)="mapService.downloadClippedLayers(paddocks)"
          [paddockSelect]="true"
          [paddocks]="paddockService.paddocks | async"
          (showPaddocks)="mapService.loadSelectedPaddocks($event)"
          [layerGroup]="mapService.enterpriseSuitibilityGroupPaddock"
        ></app-analysis-group>
        <app-topex-layer
          (downloadLayers)="mapService.downloadClippedLayers(paddocks)"
          [layer]="mapService.topexLayerProperty"
        ></app-topex-layer>
        <app-topex-layer
          (downloadLayers)="mapService.downloadClippedLayers(paddocks)"
          [layer]="mapService.topexLayerPaddock"
          [paddockSelect]="true"
          [paddocks]="paddockService.paddocks | async"
          (showPaddocks)="mapService.loadSelectedPaddocks($event)"
        ></app-topex-layer>

        <app-forest-class-layer
          (downloadLayers)="mapService.downloadClippedLayers(paddocks)"
          [layer]="mapService.forestClassesLayerProperty"
        ></app-forest-class-layer>
        <app-forest-class-layer
          (downloadLayers)="mapService.downloadClippedLayers(paddocks)"
          [layer]="mapService.forestClassesLayerPaddock"
          [paddockSelect]="true"
          [paddocks]="paddockService.paddocks | async"
          (showPaddocks)="mapService.loadSelectedPaddocks($event)"
        ></app-forest-class-layer>

        <app-layer-group
          [layerGroup]="mapService.propertyLayerGroup"
        ></app-layer-group>

        <app-layer-group
          [layerGroup]="mapService.clippedLayerGroup"
        ></app-layer-group>

        <app-layer-group
          [layerGroup]="mapService.alertsGroup"
        ></app-layer-group>

        <app-base-group [layerGroup]="mapService.basemapGroup"></app-base-group>

        <div id="layers" class="layer-switcher layer-switcher-sidebar"></div>
      </div>
    </ng-template>
  </sidebar-item>

  <!-- Create Property Sidebar Item -->
  <sidebar-item
    id="create-property"
    title="Create Property"
    className="fa fa-plus"
    [position]="2"
  >
    <ng-template #sidebarIcon>
      <i class="fa fa-plus"></i>
    </ng-template>

    <ng-template #header>
      <div class="flex items-center justify-between">
        <h2 class="text-lg font-semibold">Create Property</h2>
        <button class="text-gray-500 hover:text-gray-700">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </ng-template>

    <ng-template #content>
      <div class="p-6 space-y-6">
        <!-- Step 1: Search -->
        <div data-tour="create-property-stage-1" class="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div class="flex items-center mb-3">
            <div
              class="flex-shrink-0 w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-semibold"
            >
              1
            </div>
            <h3 class="ml-3 text-lg font-semibold text-blue-900">
              Find Your Property
            </h3>
          </div>
          <p class="text-blue-800 mb-4">
            Use the search tool below to find your property location or zoom
            manually on the map.
          </p>

          <geocode
            [map]="mapService.map"
            [contained]="true"
            popperHelp
            helpOrder="1"
            helpStage="3"
            helpContent="Use the search bar to find your property or zoom your property manually in the map."
            helpPlacement="right"
            helpTitle="Help - Create Property"
            [helpPreShowFunction]="openSidebarPane"
            helpPreShowFunctionParams="createProperty"
          ></geocode>
        </div>

        <!-- Step 2: Select Parcels -->
        <div class="bg-green-50 border border-green-200 rounded-lg p-4">
          <div class="flex items-center mb-3">
            <div
              class="flex-shrink-0 w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-semibold"
            >
              2
            </div>
            <h3 class="ml-3 text-lg font-semibold text-green-900">
              Select Property Boundaries
            </h3>
          </div>
          <p class="text-green-800 mb-4">
            Zoom in until land title parcel boundaries appear, then select each
            parcel that makes up your property.
          </p>

          @if (zoomLevel < cadasterRequiredZoomLevel) {
          <div
            class="bg-yellow-100 border border-yellow-300 rounded-lg p-3 mb-4"
          >
            <div class="flex items-center">
              <i class="fas fa-exclamation-triangle text-yellow-600 mr-2"></i>
              <p class="text-yellow-800 font-medium">
                Please zoom closer to make land title boundaries appear
              </p>
            </div>
          </div>
          }

          <app-select-property
            [map]="mapService.map"
            [layers]="[mapService.cadasterLayer]"
            multiSelectAttribute="PID"
            [helpPreShowFunction]="openSidebarPane"
            (PropertySelectChanged)="populateCreatePropertyDefaults($event)"
            popperHelp
            helpOrder="2"
            helpStage="3"
            helpContent="When this is active (highlighted in red) you can select your property boundary on the map"
            helpPlacement="right"
            helpTitle="Help - Create Property"
            [helpPreShowFunction]="openSidebarPane"
            helpPreShowFunctionParams="createProperty"
          ></app-select-property>
        </div>

        <!-- Step 3: Create Property -->
        <div class="bg-purple-50 border border-purple-200 rounded-lg p-4">
          <div class="flex items-center mb-3">
            <div
              class="flex-shrink-0 w-8 h-8 bg-purple-600 text-white rounded-full flex items-center justify-center text-sm font-semibold"
            >
              3
            </div>
            <h3 class="ml-3 text-lg font-semibold text-purple-900">
              Create Property
            </h3>
          </div>
          <p class="text-purple-800 mb-4">
            Once you've selected all parcels, create your property from the
            <span
              class="inline-flex items-center px-2 py-1 rounded-full text-sm font-medium bg-purple-100 text-purple-800"
            >
              {{ selectedBoundariesCount }} selected parcels
            </span>
          </p>
          <button
            class="w-full px-6 py-3 bg-purple-600 text-white font-semibold rounded-lg hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 flex items-center justify-center"
            [disabled]="!featureSelected"
            (click)="saveProperty()"
            popperHelp
            helpOrder="3"
            helpStage="3"
            helpContent="Once you have selected all the boundaries that mark your property click this button to being the creation process."
            helpPlacement="right"
            helpTitle="Help - Create Property"
            [helpPreShowFunction]="openSidebarPane"
            helpPreShowFunctionParams="createProperty"
          >
            <i class="fas fa-plus mr-2"></i>
            Create Property
          </button>
        </div>
      </div>
    </ng-template>
  </sidebar-item>

  <!-- Manage Properties Sidebar Item -->
  <sidebar-item
    id="manage-properties"
    title="Manage Properties"
    className="fa fa-pen"
    [position]="3"
  >
    <ng-template #sidebarIcon>
      <i class="fa fa-pen"></i>
    </ng-template>

    <ng-template #header>
      <div class="flex items-center justify-between">
        <h2 class="text-lg font-semibold">Manage Properties</h2>
        <button class="text-gray-500 hover:text-gray-700">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </ng-template>

    <ng-template #content>
      <div class="p-4">
        <div
          class="sidebar-main"
        >
          <div
            *ngFor="let property of sortedProperties()"
            [class]="
              'bg-white rounded-xl shadow-sm border p-4 mb-3 hover:shadow-md transition-all duration-200 ' +
              (activeProperty()?.propertyID === property.propertyID
                ? 'border-blue-500 bg-blue-50 shadow-blue-100'
                : 'border-gray-100 hover:border-gray-200')
            "
          >
            <!-- Header with status and info -->
            <div class="flex items-center gap-3 mb-4">
              <div
                [class]="
                  'w-2.5 h-2.5 rounded-full flex-shrink-0 ' +
                  (activeProperty()?.propertyID === property.propertyID
                    ? 'bg-blue-500'
                    : 'bg-green-500')
                "
              ></div>
              <div class="flex-1 min-w-0">
                <h3
                  [class]="
                    'text-sm font-medium truncate ' +
                    (activeProperty()?.propertyID === property.propertyID
                      ? 'text-blue-900'
                      : 'text-gray-900')
                  "
                  appTooltip="{{ property.name }}"
                  tooltipPosition="left"
                >
                  {{ property.name | truncateText : 25 }}
                  @if (activeProperty()?.propertyID === property.propertyID) {
                  <span
                    class="ml-2 text-xs bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full font-medium"
                    >ACTIVE</span
                  >
                  }
                </h3>
                <p class="text-xs text-gray-500 mt-0.5">
                  {{ property.area | round : 1 }} hectares
                </p>
                <!-- Additional property information -->
                <div class="flex items-center gap-4 mt-2 text-xs text-gray-400">
                  <div class="flex items-center gap-1">
                    <i class="fas fa-calendar-plus text-xs"></i>
                    <span>{{ property.createdOn | date : 'MMM d, y' }}</span>
                  </div>
                  <div class="flex items-center gap-1">
                    <i class="fas fa-edit text-xs"></i>
                    <span>{{ property.modifiedOn | date : 'MMM d, y' }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Action buttons -->
            <div class="flex gap-2">
              @if (activeProperty()?.propertyID === property.propertyID) {
              <button
                class="flex-1 bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium py-2.5 px-3 rounded-lg transition-colors duration-200 flex items-center justify-center gap-1.5"
                (click)="deactivateProperty()"
              >
                <i class="fas fa-times text-xs leading-none"></i>
                <span>Deactivate</span>
              </button>
              } @else {
              <button
                class="flex-1 bg-blue-50 hover:bg-blue-100 text-blue-700 text-xs font-medium py-2.5 px-3 rounded-lg transition-colors duration-200 flex items-center justify-center gap-1.5"
                (click)="mapService.setActiveProperty(property)"
              >
                <i class="fas fa-check text-xs leading-none"></i>
                <span>Set Active</span>
              </button>
              }
              <button
                class="flex-1 bg-gray-50 hover:bg-gray-100 text-gray-700 text-xs font-medium py-2.5 px-3 rounded-lg transition-colors duration-200 flex items-center justify-center gap-1.5"
                (click)="editProperty(property)"
              >
                <i class="fas fa-edit text-xs leading-none"></i>
                <span>Edit</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </sidebar-item>

  <!-- Paddocks Sidebar Item -->
  <sidebar-item
    id="paddocks"
    title="Paddocks"
    className="fa fa-vector-square"
    [position]="4"
    [disabled]="!isActivePropertySelected()"
  >
    <ng-template #sidebarIcon>
      <i class="fa fa-vector-square"></i>
    </ng-template>

    <ng-template #header>
      <div class="flex items-center justify-between">
        <h2 class="text-lg font-semibold">Paddocks</h2>
        <button class="text-gray-500 hover:text-gray-700">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </ng-template>

    <ng-template #content>
      <div class="p-4">
        <div
          class="sidebar-main"
          popperHelp
          helpOrder="1"
          helpStage="4"
          helpContent="A list of paddocks created will appear here. you will be able to edit/delete them."
          helpPlacement="right"
          helpTitle="Help - Manage Paddocks"
          [helpPreShowFunction]="openSidebarPane"
          helpPreShowFunctionParams="paddocks"
        >
          <button
            class="w-full bg-green-600 hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-medium py-3 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 flex items-center justify-center space-x-2 mb-4"
            [ngClass]="{
              'bg-orange-600 hover:bg-orange-700':
                digitizePaddockComponent?.active() === true
            }"
            [disabled]="!isActivePropertySelected()"
            (click)="digitizePaddockComponent.toggleDigitizePaddock()"
            popperHelp
            helpOrder="2"
            helpStage="4"
            helpContent="click this to start digitizing paddocks on your property."
            helpPlacement="right"
            helpTitle="Help - Manage Paddocks"
            [helpPreShowFunction]="openSidebarPane"
            helpPreShowFunctionParams="paddocks"
          >
            <i
              class="fas"
              [class]="
                digitizePaddockComponent?.active() ? 'fa-stop' : 'fa-plus'
              "
            ></i>
            <span>{{
              digitizePaddockComponent?.active()
                ? 'Stop Creating'
                : 'Create Paddock'
            }}</span>
          </button>
          <div
            *ngFor="let paddock of paddockService.paddocks | async"
            class="bg-white rounded-xl shadow-sm border border-gray-100 p-4 mb-3 hover:shadow-md hover:border-gray-200 transition-all duration-200"
          >
            <!-- Header with status and info -->
            <div class="flex items-center gap-3 mb-4">
              <div
                class="w-2.5 h-2.5 bg-blue-500 rounded-full flex-shrink-0"
              ></div>
              <div class="flex-1 min-w-0">
                <h3
                  class="text-sm font-medium text-gray-900 truncate"
                  appTooltip="{{ paddock.name }}"
                  tooltipPosition="left"
                >
                  {{ paddock.name | truncateText : 25 }}
                </h3>
                <p class="text-xs text-gray-500 mt-0.5">
                  {{ paddock.area | round : 1 }} hectares
                </p>
              </div>
            </div>

            <!-- Action buttons -->
            <div class="flex gap-2">
              <button
                class="flex-1 bg-green-50 hover:bg-green-100 text-green-700 text-xs font-medium py-2.5 px-3 rounded-lg transition-colors duration-200 flex items-center justify-center gap-1.5"
                (click)="ZoomToPaddock(paddock)"
              >
                <i class="fas fa-search-plus text-xs"></i>
                <span>Zoom</span>
              </button>
              <button
                class="flex-1 bg-gray-50 hover:bg-gray-100 text-gray-700 text-xs font-medium py-2.5 px-3 rounded-lg transition-colors duration-200 flex items-center justify-center gap-1.5"
                (click)="editPaddock(paddock)"
              >
                <i class="fas fa-edit text-xs"></i>
                <span>Edit</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </sidebar-item>

  <!-- Fences Sidebar Item -->
  <sidebar-item
    id="fences"
    title="Fences"
    className="fa fa-wave-square"
    [position]="5"
    [disabled]="!isActivePropertySelected()"
  >
    <ng-template #sidebarIcon>
      <i class="fa fa-wave-square"></i>
    </ng-template>

    <ng-template #header>
      <div class="flex items-center justify-between">
        <h2 class="text-lg font-semibold">Fences</h2>
        <button class="text-gray-500 hover:text-gray-700">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </ng-template>

    <ng-template #content>
      <div class="p-4">
        <div
          class="sidebar-main"
          popperHelp
          helpOrder="1"
          helpStage="5"
          helpContent="A list of fences created will appear here. you will be able to edit/delete them."
          helpPlacement="right"
          helpTitle="Help - Manage Fences"
          [helpPreShowFunction]="openSidebarPane"
          helpPreShowFunctionParams="fences"
        >
          <button
            class="w-full bg-purple-600 hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-medium py-3 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 flex items-center justify-center space-x-2 mb-4"
            [ngClass]="{
              'bg-orange-600 hover:bg-orange-700':
                digitizeFenceComponent?.active() === true
            }"
            [disabled]="activeProperty() == null"
            (click)="digitizeFenceComponent.toggleDigitizeFence()"
            popperHelp
            helpOrder="2"
            helpStage="5"
            helpContent="Click this button to start digitizing fences on your property."
            helpPlacement="right"
            helpTitle="Help - Manage Fences"
            [helpPreShowFunction]="openSidebarPane"
            helpPreShowFunctionParams="fences"
          >
            <i
              class="fas"
              [class]="digitizeFenceComponent?.active() ? 'fa-stop' : 'fa-plus'"
            ></i>
            <span>{{
              digitizeFenceComponent?.active()
                ? 'Stop Creating'
                : 'Create Fence'
            }}</span>
          </button>
          <div
            *ngFor="let fence of fenceService.fences | async"
            class="bg-white rounded-xl shadow-sm border border-gray-100 p-4 mb-3 hover:shadow-md hover:border-gray-200 transition-all duration-200"
          >
            <!-- Header with status and info -->
            <div class="flex items-center gap-3 mb-4">
              <div
                class="w-2.5 h-2.5 bg-purple-500 rounded-full flex-shrink-0"
              ></div>
              <div class="flex-1 min-w-0">
                <h3
                  class="text-sm font-medium text-gray-900 truncate"
                  appTooltip="{{ fence.name }}"
                  tooltipPosition="left"
                >
                  {{ fence.name | truncateText : 25 }}
                </h3>
                <p class="text-xs text-gray-500 mt-0.5">
                  {{ fence.length | round : 1 }} meters
                </p>
              </div>
            </div>

            <!-- Action buttons -->
            <div class="flex gap-2">
              <button
                class="flex-1 bg-purple-50 hover:bg-purple-100 text-purple-700 text-xs font-medium py-2.5 px-3 rounded-lg transition-colors duration-200 flex items-center justify-center gap-1.5"
                (click)="map.zoomToFence(fence)"
              >
                <i class="fas fa-search-plus text-xs"></i>
                <span>Zoom</span>
              </button>
              <button
                class="flex-1 bg-gray-50 hover:bg-gray-100 text-gray-700 text-xs font-medium py-2.5 px-3 rounded-lg transition-colors duration-200 flex items-center justify-center gap-1.5"
                (click)="editFence(fence)"
              >
                <i class="fas fa-edit text-xs"></i>
                <span>Edit</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </sidebar-item>

  <!-- Reporting Sidebar Item -->
  <sidebar-item
    id="reporting"
    title="Reporting"
    className="fa fa-chart-bar"
    [position]="6"
    [disabled]="!isActivePropertySelected()"
  >
    <ng-template #sidebarIcon>
      <i
        class="fa fa-chart-bar"
        [ngClass]="{
          'animate-pulse text-yellow-400': isActivePropertySelected()
        }"
      ></i>
    </ng-template>

    <ng-template #header>
      <div class="flex items-center justify-between">
        <h2 class="text-lg font-semibold">Reporting</h2>
        <button class="text-gray-500 hover:text-gray-700">
          <i class="fa fa-chart-bar"></i>
        </button>
      </div>
    </ng-template>

    <ng-template #content>
      <div class="p-4">
        <div class="sidebar-main">
          <label
            for="reportingToolType"
            class="block text-sm font-medium text-gray-700 mb-2"
            >Tool
            <select
              [(ngModel)]="reportingToolType"
              name="reportingToolType"
              class="custom-select"
              id="reportingToolType"
              required
            >
              <option value="1">Crop/Species Decision Support Tool</option>
              <option appRole="['Administrator']" value="2">
                Forestry Management Baseline Costs and Benefits Tool
              </option>
              <option value="3">Topex Score Support Tool</option>
              <option value="4">Farm Woodlot Tool</option>
              <option value="5">Forest Description Tool</option>
              <option value="6">Pine Economic Analysis Tool</option>
            </select>
          </label>
          @if (activeProperty() !== null) {
            <div class="reporting-target_container">
              @if (reportingToolType == 1) {
                <app-report-card
                  [property]="activeProperty()"
                  [paddocks]="paddocks"
                  [multi]="true"
                  (runReport)="showCropReport($event)"
                >
                  <p>
                    This Tool will summarize and rank suitability by area for key
                    crop or tree species for your Property or chosen Paddocks.
                    Suitability is derived from the Enterprise Suitability Maps
                    which were compiled by the Department of Natural Resources and
                    Environment Tasmania (NRET). The maps apply a set of crop rules
                    against the modelled climatic, soil and landscape conditions to
                    show which areas have the best or worst conditions for
                    particular crops or enterprises.
                    <br /><br />
                    More information about the Enterprise Suitability Maps, and the
                    specific rules applied to each crop or tree species, can be
                    found
                    <a
                      target="_blank"
                      href="https://nre.tas.gov.au/agriculture/investing-in-irrigation/enterprise-suitability-toolkit/enterprise-suitability-maps"
                    >here</a
                    >
                  </p>
                </app-report-card>
              } @else if (reportingToolType == 2) {
                <app-report-card
                  [property]="activeProperty()"
                  [paddocks]="paddocks"
                  [multi]="false"
                  (runReport)="showNPVCalculator($event)"
                >
                  <p>
                    This calculator provides a summary of key baseline costs and
                    benefits for standing native forest and plantation forestry
                    management enterprises, against which sensitivity analysis can
                    be undertaken to provide insight into the main drivers of forest
                    value at harvest. The calculator was developed by the Forest
                    Practices Authority.
                    <br /><br />
                    Any input values set as default by the calculator, and any
                    calculated output dollar values are indicative only, and should
                    not be relied upon. You should consult professional advice
                    should you need an accurate valuation of your forest.
                    <br /><br />
                    More information about the Forestry Management Baseline Costs
                    And Benefits Tool can be found
                    <a target="_blank" href="https://www.fpa.tas.gov.au/">here</a>
                  </p>
                </app-report-card>
              } @else if (reportingToolType == 3) {
                <app-report-card
                  [property]="activeProperty()"
                  [paddocks]="paddocks"
                  [multi]="true"
                  (runReport)="showTopexReport($event)"
                >
                  <p>
                    The Topex Score Support Tool was designed to generate inputs for
                    Private Forests Tasmania's 'Wind Risk Calculator' available for
                    download
                    <a
                      target="_blank"
                      href="https://treealliance.com.au/wind-risk-calculator"
                    >here</a
                    >. Within Tasmania the forest wind risk must not be
                    underestimated. The establishment and management of forests,
                    plantation and native, can be severely affected by wind if it is
                    not assessed as part of the strategic forest planning process,
                    failure to assess this could result in commercial failure. For
                    more information about the risk of wind damaging forests in
                    Tasmania, please refer to this link
                    <a
                      target="_blank"
                      href="https://pft.tas.gov.au/volumes/documents/Wind-Risk/Forest-and-wind-risk-in-Tasmania.pdf"
                    >here</a
                    >.
                  </p>
                </app-report-card>
              } @else if (reportingToolType == 4) {
                <app-report-card
                  [property]="activeProperty()"
                  [paddocks]="paddocks"
                  [multi]="false"
                  (runReport)="showWoodlotTool($event)"
                >
                  <p>
                    The Farm Woodlot Tool provides a set of simple calculators and
                    reference material to help you understand the main requirements
                    to achieve a successful tree enterprise from establishment
                    through management to harvest and marketing
                    <br /><br />
                    Like any agricultural enterprise it is wise to prepare a simple
                    management plan considering establishment costs, market
                    location, product requirements, wood prices and plantation
                    management options. The Farm Woodlot Tool provides a set of
                    guidelines and calculators to assist with successful
                    establishment of trees on farm land, including indication of
                    likely yields and markets.
                    <br /><br />
                    If you need more background information on why and how you might
                    grow trees on your property, or a basic overview of the likely
                    timing and planning required for tree establishment, please
                    click
                    <a
                      target="_blank"
                      href="https://pft.tas.gov.au/6-steps-to-growing"
                    >here</a
                    >. If in doubt, seek professional advice from Private Forests
                    Tasmania.
                  </p>
                </app-report-card>
              } @else if (reportingToolType == 5) {
                <app-report-card
                  [property]="activeProperty()"
                  [paddocks]="paddocks"
                  [multi]="true"
                  (runReport)="showForestReport($event)"
                >
                  <p>
                    The Forest Description Tool will summarize the area of native
                    forest for your Property or chosen Paddocks, and provide an
                    indicative estimate of the amount of timber products that might
                    be standing in that forest, some of which might be available for
                    harvest under an approved Forest Practices Plan.
                    <br /><br />
                    The native forest mapping and classification underpinning this
                    tool is managed by Private Forests Tasmania, and is sourced from
                    a mix of aerial and satellite imagery of various ages. Some of
                    the mapping reaches back to 1995, but as part of PFT's annual
                    forest review program, every effort has been made to update the
                    mapping where changes have been identified. We would welcome
                    feedback via this app where you note significant differences in
                    the mapping for your Property.
                  </p>
                </app-report-card>
              }
              @else if (reportingToolType == 6) {
                <app-report-card
                  [property]="activeProperty()"
                  [paddocks]="paddocks"
                  [multi]="false"
                  (runReport)="showPineAnalysisReport($event)"
                >
                  <p>
                    This tool is designed to assist you with your decision to plant trees on your property in Tasmania.
                    It is a simplified economics model that will estimate the Net Present Value (NPV) and the
                    Internal Rate of Return (IRR) based upon planting <i>Pinus radiata</i>, with or without thinning, and with or without carbon credits.
                    <br /><br />
                    Private Forests Tasmania assumes no legal or financial responsibility or liability for assumptions
                    and calculations made to users of the Pine Economic Analysis Tool. Any decisions made by the user
                    based off reports developed from the Pine Economic Analysis Tool remain the sole legal and financial
                    liability of the user.
                  </p>
                </app-report-card>
              }
            </div>
          }
        </div>
      </div>
    </ng-template>
  </sidebar-item>

  <!-- Help Sidebar Item -->
  <sidebar-item
    id="help"
    title="Help"
    className="fa fa-question-circle"
    [position]="7"
  >
    <ng-template #sidebarIcon>
      <i class="fa fa-question-circle"></i>
    </ng-template>

    <ng-template #header>
      <div class="flex items-center justify-between">
        <h2 class="text-lg font-semibold">Help</h2>
        <button class="text-gray-500 hover:text-gray-700">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </ng-template>

    <ng-template #content>
      <div class="p-4">
        <div class="sidebar-main">
          <mat-form-field appearance="fill">
            <mat-label>Select a help stage</mat-label>
            <br />
            <mat-select [(value)]="helpStage">
              <mat-option value="1">Welcome</mat-option>
              <mat-option value="2">Map Tools</mat-option>
              <mat-option value="3">Create Property</mat-option>
              <mat-option value="4">Create Paddock</mat-option>
              <mat-option value="5">Create Fences</mat-option>
            </mat-select>
          </mat-form-field>
          <button (click)="showHelpGuide()" class="button button--blue">
            Show Help Guide
          </button>

                  <button routerLink="/admin" appRole="['Administrator']" mat-menu-item>Admin</button>
        </div>
      </div>
    </ng-template>
  </sidebar-item>
</sidebar-overlay>

<ng-template #dialog let-close="close">
  <esk-dialog header="Welcome to the Farm and Forest Mapper">
    <div class="flex flex-col h-full w-full">
      <div class="flex-grow px-6 py-6 overflow-y-auto">
        <div class="prose prose-gray max-w-none">
          <p class="text-gray-700 leading-relaxed mb-4">
            Farm and Forest Mapper is a set of mapping and decision support tools and calculators, designed to assist
            you with making informed decisions on your property, with emphasis on assisting you with establishing or
            managing forests to leverage the wide range of benefits that trees on farms provide.
            Any feedback or ideas of tools or calculators you might find helpful into the future is welcome.
          </p>

          <p class="text-gray-700 leading-relaxed mb-4">
            To work, Farm and Forest Mapper requires your property boundary to be defined in the map, from which it can
            extract and analyse map based models and information. So, the very first thing you need to do is search in
            the map for the property you're interested in and select the titles comprising it, which Farm and Forest
            Mapper will save as property boundary so you can use it again and again. From there you're free to apply
            any of the Farm and Forest Mapper tools or calculators to analyse the whole property, but you can also
            optionally map out and analyse paddocks or fence lines that are within the property if you need to fine
            tune analysis to a specific part of the property.
          </p>

          <p class="text-gray-700 leading-relaxed mb-0">
            Private Forest Tasmania and the Forest Practices Authority hope you enjoy using these tools, and can gain
            valuable insights to support your farming and forest enterprises!
          </p>
        </div>
      </div>

      <div
        class="bg-gray-50 px-6 py-4 border-t flex flex-row items-center justify-between border-gray-200"
      >
        <!-- Logos section at the bottom -->
        <section class="logos flex justify-center items-center space-x-6 mb-4">
          <img
            class="h-10 w-auto opacity-70 hover:opacity-100 transition-opacity duration-200"
            src="assets/images/PFT-Logo-Dark.png"
            alt="Private Forest Tasmania"
          />
          <img
            class="h-10 w-auto opacity-70 hover:opacity-100 transition-opacity duration-200"
            src="assets/images/fpa_logo.png"
            alt="Forest Practices Authority"
          />
          <img
            class="h-10 w-auto opacity-70 hover:opacity-100 transition-opacity duration-200"
            src="assets/images/esk-logo-large-transparent-dark-trimmed.png"
            alt="ESK"
          />
        </section>

        <!-- Buttons section -->
        <div class="flex items-center justify-between">
          <div class="flex flex-col space-y-3">
            <label class="flex items-center cursor-pointer group">
              <input
                type="checkbox"
                class="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 transition-colors duration-200"
                [checked]="dontShowAgain()"
                (change)="dontShowAgain.set($any($event.target).checked)"
              />
              <span
                class="ml-3 text-sm font-medium text-gray-700 group-hover:text-gray-900 transition-colors duration-200"
              >
                Don't show this again?
              </span>
            </label>
            <label class="flex items-center cursor-pointer group">
              <input
                type="checkbox"
                class="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 transition-colors duration-200"
                [checked]="startHelp()"
                (change)="startHelp.set($any($event.target).checked)"
              />
              <span
                class="ml-3 text-sm font-medium text-gray-700 group-hover:text-gray-900 transition-colors duration-200"
              >
                Start help?
              </span>
            </label>
          </div>

          <button
            (click)="handleClose(close)"
            class="px-6 py-2.5 text-sm font-semibold text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-3 focus:ring-blue-500 focus:ring-opacity-50 shadow-sm hover:shadow-md transition-all duration-200"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </esk-dialog>
</ng-template>
